import { groupBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useAuthenticatedAPI } from '../../../state';
import { useQueueAPI } from '../queue/selectors';
import { usePlanAPI, useWizardParams } from '../selectors';
import { useWizardSimpleContext } from '../useWizardSimpleContext';
export var SHRINKAGE_API = '/api/shrinkage/{queueId}';
export var SHRINKAGE_CREATE_API = '/api/shrinkage';
export var SHRINKAGE_COPY_API = '/api/shrinkage/{destQueueId}/copy';
export var SHRINKAGE_DEFAULTS_API = '/api/shrinkage/defaults/{planLocationId}';
export var SHRINKAGE_FACTOR_API = '/api/shrinkage/factor';
export var SHRINKAGE_PLAN_OPTIONS_API = '/api/shrinkage/plan/{planId}/options';
export var useShrinkageTable = function (queueLocationId) {
    var _a;
    var queue = ((_a = useWizardSimpleContext()) !== null && _a !== void 0 ? _a : {}).queue;
    var shrinkages = useMemo(function () {
        var _a, _b, _c, _d;
        if (!queueLocationId) {
            return (_a = queue === null || queue === void 0 ? void 0 : queue.shrinkages) !== null && _a !== void 0 ? _a : [];
        }
        return (_d = (_c = (_b = queue === null || queue === void 0 ? void 0 : queue.queueLocations) === null || _b === void 0 ? void 0 : _b.find(function (location) { return location.id === queueLocationId; })) === null || _c === void 0 ? void 0 : _c.shrinkages) !== null && _d !== void 0 ? _d : [];
    }, [queue === null || queue === void 0 ? void 0 : queue.shrinkages, queue === null || queue === void 0 ? void 0 : queue.queueLocations, queueLocationId]);
    return useMemo(function () {
        return groupBy(shrinkages, function (shrinkage) {
            var _a, _b, _c, _d;
            return "".concat((_a = shrinkage.shrinkageCategory) !== null && _a !== void 0 ? _a : '', "|").concat((_c = (_b = shrinkage.shrinkageSubcategory) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : '', "|").concat(shrinkage.name, "|").concat((_d = shrinkage.shrinkageType) !== null && _d !== void 0 ? _d : '');
        });
    }, [shrinkages]);
};
export var useShrinkageDefaultsAPI = function (planLocationId) {
    return useAuthenticatedAPI(SHRINKAGE_DEFAULTS_API, { planLocationId: planLocationId }, 'GET');
};
export var useShrinkagePlanOptionsAPI = function () {
    var _a;
    var planData = usePlanAPI()[0];
    var queueData = useQueueAPI()[0];
    var planId = (_a = planData.data) === null || _a === void 0 ? void 0 : _a.basePlanId;
    var _b = useAuthenticatedAPI(SHRINKAGE_PLAN_OPTIONS_API, { planId: planId }, 'GET'), data = _b[0], fetchData = _b[1], clearData = _b[2];
    var fetchDataWrapper = useCallback(function () {
        if (planId || !!(queueData === null || queueData === void 0 ? void 0 : queueData.data)) {
            fetchData();
        }
    }, [fetchData, planId, queueData === null || queueData === void 0 ? void 0 : queueData.data]);
    return [data, fetchDataWrapper, clearData];
};
export var useAddShrinkageAPI = function () {
    return useAuthenticatedAPI(SHRINKAGE_CREATE_API, undefined, 'POST');
};
export var useUpdateShrinkageFactorAPI = function () {
    return useAuthenticatedAPI(SHRINKAGE_FACTOR_API, undefined, 'PATCH');
};
export var useDeleteShrinkageFactorAPI = function () {
    return useAuthenticatedAPI(SHRINKAGE_FACTOR_API, undefined, 'DELETE');
};
export var useClearShrinkageAPI = function (queueLocationId) {
    var queueId = useWizardParams().queueId;
    var _a = useAuthenticatedAPI(SHRINKAGE_API, { queueId: queueId }, 'DELETE'), data = _a[0], fetchData = _a[1], clearData = _a[2];
    var fetchDataWrapper = useCallback(function (selectedQueueLocationId) {
        if (selectedQueueLocationId === void 0) { selectedQueueLocationId = queueLocationId; }
        fetchData(undefined, { queueLocationId: selectedQueueLocationId !== null && selectedQueueLocationId !== void 0 ? selectedQueueLocationId : undefined });
    }, [fetchData, queueLocationId]);
    return [data, fetchDataWrapper, clearData];
};
export var useCopyShrinkageAPI = function () {
    var destQueueId = useWizardParams().queueId;
    var _a = useAuthenticatedAPI(SHRINKAGE_COPY_API, { destQueueId: destQueueId }, 'POST'), data = _a[0], fetchData = _a[1], clearData = _a[2];
    var fetchDataWrapper = useCallback(function (_a) {
        var sourceQueueId = _a.sourceQueueId, sourceQueueLocationId = _a.sourceQueueLocationId, destQueueLocationId = _a.destQueueLocationId;
        if (destQueueId) {
            fetchData(undefined, {
                sourceQueueId: sourceQueueId,
                sourceQueueLocationId: sourceQueueLocationId !== null && sourceQueueLocationId !== void 0 ? sourceQueueLocationId : undefined,
                destQueueLocationId: destQueueLocationId !== null && destQueueLocationId !== void 0 ? destQueueLocationId : undefined,
            });
        }
    }, [fetchData, destQueueId]);
    return [data, fetchDataWrapper, clearData];
};
